//Using the same names from our design guidelines
const designPallete = {
  primaryLightMode: '#FFFFFF',
  secondaryLightMode: '#FAFAFF',
  primaryDarkMode: '#131319',
  secondaryDarkMode: '#1C1D26',
  accentGreen: '#107F10',
  accentRed: '#D90D02',
  font: {
    primaryLightMode: '#131319',
    secondaryLightMode: '#73738C',
    primaryDarkMode: '#FFFFFF',
    secondaryDarkMode: '#8C8EA1'
  }
}

const unmmapedColors = {
  dividerColorLightMode: '#D5D6EA77',
  dividerColorDarkMode: '#FFFFFF11',
  inputBorderColorLightMode: '#D5D6EA',
  inputBorderColorDarkMode: '#FFFFFF',
  borderColorLightMode: '#E2E2E2',
  borderColorDarkMode: '#1D1D1D',
  accentYellow: '#FFCE45'
}

const fonts = {
  roboto: 'Roboto',
  canela: 'Canela'
}

//translating the design guidelines to something more generic
//we can use this for our styled components easily

export const defaultTheme = {
  background: designPallete.primaryLightMode,
  backgroundAlt: designPallete.secondaryLightMode,
  primaryColor: designPallete.font.primaryLightMode,
  secondaryColor: designPallete.font.secondaryLightMode,
  dangerColor: designPallete.accentRed,
  successColor: designPallete.accentGreen,
  warningColor: unmmapedColors.accentYellow,
  dividerColor: unmmapedColors.dividerColorLightMode,
  borderColor: unmmapedColors.borderColorLightMode,
  toast: {
    width: '450px',
    height: '52px'
  },
  typography: {
    fontFamily: fonts.roboto,
    primaryColor: designPallete.font.primaryLightMode,
    secondaryColor: designPallete.font.secondaryDarkMode,
    headers: {
      fontFamily: fonts.canela,
      size: '24px'
    },
    sizes: {
      desktop: {
        small: '12px',
        medium: '16px'
      },
      mobile: {
        small: '10px',
        medium: '14px'
      }
    }
  },
  gallery: {
    background: `${designPallete.primaryLightMode}ee`
  },
  input: {
    color: designPallete.font.secondaryLightMode,
    borderColor: unmmapedColors.inputBorderColorLightMode,
    label: {
      color: designPallete.font.secondaryLightMode
    }
  },
  select: {
    color: designPallete.font.primaryLightMode
  },
  backdropColor: 'rgba(250, 250, 255, 0.6)',
  boxShadowColor: 'rgba(0, 0, 0, 0.1)',
  isDark: false
}

export type Theme = typeof defaultTheme

export const darkTheme: Theme = {
  background: designPallete.primaryDarkMode,
  backgroundAlt: designPallete.secondaryDarkMode,
  primaryColor: designPallete.font.primaryDarkMode,
  secondaryColor: designPallete.font.primaryDarkMode,
  dangerColor: designPallete.accentRed,
  successColor: designPallete.accentGreen,
  warningColor: unmmapedColors.accentYellow,
  dividerColor: unmmapedColors.dividerColorDarkMode,
  borderColor: unmmapedColors.borderColorDarkMode,
  toast: defaultTheme.toast,
  typography: {
    fontFamily: fonts.roboto,
    primaryColor: designPallete.font.primaryDarkMode,
    secondaryColor: designPallete.font.secondaryDarkMode,
    headers: defaultTheme.typography.headers,
    sizes: defaultTheme.typography.sizes
  },
  gallery: {
    background: `${designPallete.primaryDarkMode}22`
  },
  input: {
    color: designPallete.font.secondaryDarkMode,
    borderColor: unmmapedColors.inputBorderColorDarkMode,
    label: {
      color: designPallete.font.secondaryDarkMode
    }
  },
  select: {
    color: designPallete.font.primaryDarkMode
  },
  backdropColor: 'rgba(0, 0, 0, 0.6)',
  boxShadowColor: 'rgba(0, 0, 0, 0.1)',
  isDark: true
}
